import { defineMessages } from 'react-intl'

export default defineMessages({
  audienceTargetingDescription: {
    id: 'SpaceAppBuilderFeaturesPage.AppUITrigger.audienceTargetingDesc',
    defaultMessage: 'Setup the audience for your App UI:'
  },
  audienceTargetingRulePrefixText: {
    id: 'SpaceAppBuilderFeaturesPage.AppUITrigger.rulePrefixText',
    defaultMessage: 'This App UI will be turned on all users'
  },
  audienceTargeting: {
    id: 'SpaceAppBuilderFeaturesPage.AppUITrigger.audienceTargeting',
    defaultMessage: 'Audience Targeting'
  },
  chatDiscoverability: {
    id: 'SpaceAppBuilderFeaturesPage.AppUITrigger.chatDiscoverability',
    defaultMessage: 'Discoverability'
  },
  pleaseDefineChatDiscoverabilityPhrase: {
    id: 'SpaceAppBuilderFeaturesPage.httpRequestTrigger.pleaseDefineChatDiscoverabilityPhrase',
    defaultMessage: 'Please define a phrase.'
  },
  chatDiscoverabilityPhraseMessage: {
    id: 'SpaceAppBuilderFeaturesPage.AppUITrigger.chatDiscoverabilityPhraseMessage',
    defaultMessage:
      'Add a phrase to describe what this UI does so the chatbot can surface it in a conversation. Nouns and verbs will help discoverability.'
  },
  chatDiscoverabilityPhrasePlaceholder: {
    id: 'SpaceAppBuilderFeaturesPage.AppUITrigger.chatDiscoverabilityPhrasePlaceholder',
    defaultMessage: 'Send a reminder to employees to fill out their timesheet'
  },
  chatDiscoverabilityDesc: {
    id: 'SpaceAppBuilderFeaturesPage.AppUITrigger.chatDiscoverabilityDesc',
    defaultMessage: 'Allow Chatbot to surface this UI'
  },
  isEntry: {
    id: 'SpaceAppBuilderFeaturesPage.AppUITrigger.isEntry',
    defaultMessage: 'App Landing Page'
  },
  isEntryDescription: {
    id: 'SpaceAppBuilderFeaturesPage.AppUITrigger.isEntryDescription',
    defaultMessage: 'Set whether or not this is the first view users should see:'
  },
  payloadInvalidJson: {
    id: 'SpaceAppBuilderFeaturesPage.httpRequestTrigger.payloadInvalidJson',
    defaultMessage: 'Please enter valid JSON'
  },
  pleaseDefinePayload: {
    id: 'SpaceAppBuilderFeaturesPage.httpRequestTrigger.pleaseDefinePayload',
    defaultMessage: 'Please define a request payload'
  },
  definePayload: {
    id: 'SpaceAppBuilderFeaturesPage.httpRequestTrigger.definePayload',
    defaultMessage: 'Define Payload'
  }
})
